import classNames from "classnames";

import ReactTableCell from "./ReactTableCell";

type ReactTableRowProps = {
  row: any;
  canExpand?: boolean;
  lastViewed?: boolean;
};

const ReactTableRow = ({ row, canExpand, lastViewed }: ReactTableRowProps) => {
  const handleOnClick = (e: MouseEvent) => {
    if ((e.target as HTMLElement)?.tagName === "INPUT") return;
    row.toggleRowExpanded();
  };

  return (
    <tr
      {...row.getRowProps()}
      className={classNames(`table__row`, {
        expanded: row.isExpanded,
        lastViewed: lastViewed,
      })}
      onClick={canExpand ? handleOnClick : undefined}
    >
      {row.cells.map((cell: any) => {
        return (
          <ReactTableCell
            cell={cell}
            isCellExpanded={row.isExpanded}
            key={`row:${cell.row.id}--col:${cell.column.id}`}
          />
        );
      })}
    </tr>
  );
};

export default ReactTableRow;
